import { render, staticRenderFns } from "./NotebookItem.vue?vue&type=template&id=3714f445&scoped=true"
import script from "./NotebookItem.vue?vue&type=script&lang=js"
export * from "./NotebookItem.vue?vue&type=script&lang=js"
import style0 from "./NotebookItem.vue?vue&type=style&index=0&id=3714f445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3714f445",
  null
  
)

export default component.exports